import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";

export default class SettingsModuleAdmins extends SettingsModule {

    constructor() {
        super({
            name                     : "Admins",
            description              : "The user designated as the Administrator holds the responsibility for overseeing the organization's GoodDay account. The Administrator user enjoys equivalent access privileges as the organization's Manager user, with the added capability to navigate advanced settings and oversee the management of GoodDay account and subscription licenses. ",
            svgIcon                  : "isvg-admins",
            typeLabel                : "Organization account",
            settingsUrl              : "settings/admins",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.parentSection          = SettingsParentSection.COMPANY_USERS

        this.canDisable             = false
        this.hasStatus              = false
    }

}
